/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
:host {
  display: block;
  width: 100%;
  height: 100%;
}

#chat-message-bar {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  gap: 10px;
}

#chat-textarea {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

textarea {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  font-family: Frutiger-Light, sans-serif;
  font-size: 16px;
  padding: 5px 30px;
  border: 1px solid var(--ux-input-border-color);
  resize: none;
  overflow: auto;
  max-height: 46px;
}
textarea::placeholder {
  line-height: 36px;
}

ux-button {
  flex-shrink: 0;
  align-self: center;
  --ux-icon-button-width: 46px;
  --ux-icon-button-height: 46px;
  --ux-button-icon-size-large: 20px;
}

ux-input::part(label) {
  display: none;
}

ux-input::part(hint) {
  display: none;
}